import { render } from "./CategorySelector.vue?vue&type=template&id=5ecca93a"
import script from "./CategorySelector.vue?vue&type=script&lang=js"
export * from "./CategorySelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__